import NavMetaPages from './NavMetaPages.jsx';

function ContentPageSidebar() {
  return (
    <div>
      <NavMetaPages />
      <hr />
    </div>
  );
}

export default ContentPageSidebar
